import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Amplify from 'aws-amplify';
import awsconfig from './aws-exports';
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/scss/custom.scss'
import 'bootstrap-icons/font/bootstrap-icons.css'
import Notifications from '@kyvg/vue3-notification'

Amplify.configure(awsconfig);
createApp(App).use(store).use(router).use(Notifications).mount('#app')
